import axios from "axios";
import { useQuery } from "react-query";
import { getHeader } from "../utils/util";
import { API_ENDPOINT } from "../utils/constants";

const useTemplate = (id = "") => {
  return useQuery({
    queryKey: ["template", id],
    queryFn: async () => {
      const response = await axios.get(
        `${API_ENDPOINT}/api/template/${id}`,
        getHeader()
      );
      return response.data;
    },
    retry: 1,
    enabled: !!id,
    refetchOnWindowFocus: false,
  });
};

export default useTemplate;
